module.exports = __webpack_public_path__ + "img/D201609_3.90e04098.jpg";